import { makeBridgeRequest } from 'common/helpers'
import { Metadados } from 'common/types'
import { TEndpoint, TUserType } from 'contexts/app-context/types'

import { changePrivacies } from './br-api'

export const setPurposesBR = async (
  metadados: Metadados<TUserType>,
  userType: TUserType,
  productID: string,
  endpoint: TEndpoint,
  headers?: Record<string, string>,
) =>
  makeBridgeRequest(
    changePrivacies({ body: metadados, userType, finalidadeId: productID, endpoint, headers }),
  )
